'use client'

import { Session } from 'next-auth'
import { useQuery } from '@tanstack/react-query'
import { PATIENT_ROLE } from '@/lib/constants'
import useApiClient from '@/lib/apis/clients/useApiClient'
import { user } from '@/lib/utils'
import { checkProviderSession } from '@/lib/apis/authentication'
import { hasProviderRole } from '@/lib/auth/provider-session'
import { GetPatientAccountStatus } from '@/lib/apis/profile'
import { useEffect } from 'react'
import { logOutWithClientCleanup } from '@/lib/apis/authentication-client'

type Props = {
  session: Session | null
}

export default function AccountStatusChecker({ session }: Props) {
  const api = useApiClient()
  const { containsAny } = user(session)
  useQuery({
    queryKey: [
      'authentication',
      'provider-session',
      session?.providerSessionId,
    ],
    queryFn: async () => {
      await api.executeEmpty(checkProviderSession())
      return true
    },
    enabled: hasProviderRole(session?.user?.roles),
    refetchInterval: 5000,
  })
  const patientStatus = useQuery({
    ...GetPatientAccountStatus.query(api, session?.user?.id),
    enabled: containsAny([PATIENT_ROLE]),
    refetchInterval: 5000,
  })

  const shouldLogout =
    patientStatus.data?.disabled === true ||
    patientStatus.data?.state === 'DELETION_PENDING' ||
    patientStatus.data?.state === 'DELETED'

  useEffect(() => {
    if (shouldLogout) {
      logOutWithClientCleanup(new FormData()).then()
    }
  }, [shouldLogout])

  return <></>
}
